import { Endpoints } from 'UI/constants/endpoints';

import { sendRequest } from './utils';

/**
 * @param {string} phoneNumber
 * @returns {Promise<OperationResult>}
 */
export const searchByPhoneNumber = async phoneNumber => {
  const queryParams = new URLSearchParams({
    limit: 3,
    partialPhone: phoneNumber
  });

  const result = await sendRequest(
    `${Endpoints.Names}?${queryParams.toString()}`,
    'get',
    null,
    null,
    null,
    2
  );

  return result;
};
